module.exports = __webpack_public_path__ + "assets/img/shanghai_213_1.191e98c4.jpg";